import { allLayersOpacityProperty } from "../../constants/constants";

export function handleFeaturesOpacity(map, opacity) {
    for (const [layer, opacityProperty] of Object.entries(allLayersOpacityProperty)) {
        map.setPaintProperty(layer, opacityProperty, ['to-number', opacity, 1]);
    }
}